<template>

	<div class="page-customers flex column" id="page-customers">
		<!-- <resize-observer @notify="__resizeHanlder" /> -->

		<!-- <el-row :gutter="20" style="margin-bottom:10px;">
			<el-col>
				<span class="fs-14 secondary-text">Total : A FAIRE </span>
				<span class="fs-14 secondary-text" style="margin-left:20px;" v-if="isFiltered">Total filtré : {{count}} <el-link type="text" @click="resetAllFilters"><i class="mdi mdi-filter-remove"/></el-link></span>
			</el-col>
		</el-row> -->
		<el-row :gutter="20">
			<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
					<!-- <el-tabs tab-position="top">
						<el-tab-pane label="Toutes les fiches"> -->
							<el-input
								:placeholder="$t('credit_notes.search')"
								clearable
								v-model="creditNotesSearch"
								v-popover:popover4>
                <el-dropdown slot="append" style="border-right:1px;">
                    <el-button type="primary">
                    {{$t('common.sortBy')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :icon="sortIcon('customer.name')" @click.native="sortBy('customer.name')">Client</el-dropdown-item>
                    <el-dropdown-item :icon="sortIcon('cr_number')" @click.native="sortBy('cr_number')">Numéro de note de crédit</el-dropdown-item>
                    <el-dropdown-item :icon="sortIcon('inv_number')" @click.native="sortBy('inv_number')">Numéro de facture</el-dropdown-item>
                    <el-dropdown-item  :icon="sortIcon('updated_at')" @click.native="sortBy('updated_at')">Dernière modification</el-dropdown-item>
                    <el-dropdown-item  :icon="sortIcon('created_at')" @click.native="sortBy('created_at')">Date de création</el-dropdown-item>
                    <el-dropdown-item  :icon="sortIcon('date')" @click.native="sortBy('date')">Date</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
								<el-button slot="prepend" @click="showFilters=true"><i class="mdi mdi-filter"></i></el-button>
							</el-input>
							<div class="contacts-list" style="margin:10px;" >
									<div v-if="isTileMode" >
										<div v-if="creditNotes.length==0 && !loading" style="text-align: center;margin-top:50px;">{{$t('credit_notes.noCreditNote')}}</div>
										<div class="infinite-list" v-infinite-scroll="load" :infinite-scroll-distance="0" infinite-scroll-distance="200" style="overflow:auto;" :style="getHeightStyle">
											<div v-for="(c, index) in creditNotes" :key="c.id" class="flex contact" @click="openCreditNotes(c,index)" >
												<div class="info box grow flex">
													<div class="name box grow flex column justify-center p-10">
														<div class="fullname fs-18"><strong>{{customerName(c.customer)}}</strong></div>
                            <div class="secondary-text fs-14">{{c.cr_number}}</div>
                            <div class="secondary-text fs-14" v-if="c.invoice">{{c.invoice.inv_number}}</div>
													</div>
												  <div class="overdue flex p-10" style="flex-direction:column">
                            <span class="align-vertical-middle" style="text-align:right;">{{$n(c.total, 'currency', c.currency ? c.currency.code : 'CAD')}}</span>
                            <span class="fs-14 secondary-text" style="text-align:right;">{{$t("credit_notes.statuses."+c.status.code)}}</span>
                          </div>
												</div>
											</div>
										</div>
										<p class="fs-16 secondary-text" style="text-align:center" v-if="loading">Chargement...</p>
									</div>
									<div v-else>
										<el-card>
											<el-table
									      :data="creditNotes"
												stripe
												:height="getHeight"
												:empty-text="$t('credit_notes.noCreditNote')"
									      style="width: 100%;"
												:cell-style="{padding:'2px'}"
												v-loading="loading">
								        <el-table-column
								          label="# note de crédit" :show-overflow-tooltip="true">
								            <template slot-scope="scope">
															<PortausLink :id="scope.row.id" path="/credit-notes/" :label="scope.row.cr_number"></PortausLink>
								            </template>
								        </el-table-column>
												<el-table-column
								          :label="$t('credit_notes.name')"
								          :show-overflow-tooltip="true">
								            <template slot-scope="scope">
								              <el-link @click="openClient(scope.row.customer)">{{customerName(scope.row.customer)}}</el-link>
								            </template>
								        </el-table-column>
								        <el-table-column
								          label="Date" :show-overflow-tooltip="true">
								            <template slot-scope="scope">
								              <span>{{_moment(scope.row.date)}}</span>
								            </template>
								        </el-table-column>
								        <el-table-column
								          :label="$t('credit_notes.invoice')" :show-overflow-tooltip="true">
								            <template slot-scope="scope">
															<span v-for="(inv, index) in scope.row.invoices" :key="index">
																<br v-if="index>0">
									              <el-link @click="openInvoice(inv)">{{inv.inv_number}}</el-link>
															</span>
								            </template>
								        </el-table-column>
								        <el-table-column
								         :label="$t('credit_notes.status')" width="150">
								         <template slot-scope="scope">
								             <el-tag style="margin-right:5px;" v-if="scope.row.status">{{$t('credit_notes.statuses.'+scope.row.status.code)}}</el-tag>
								         </template>
								       </el-table-column>
								       <el-table-column
								        :label="$t('credit_notes.total')" width="150" :show-overflow-tooltip="true">
								        <template slot-scope="scope">
								          <span >{{$n(scope.row.total, 'currency', scope.row.currency? scope.row.currency.code : 'CAD')}}</span>
								        </template>
								      </el-table-column>
												<infinite-loading
										      slot="append"
													ref="infiniteLoading"
										      @infinite="load"
										      force-use-infinite-wrapper=".el-table__body-wrapper">
										    </infinite-loading>
									    </el-table>
										</el-card>
									</div>
								</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import CreditNoteTable from '@/components/creditNote/credit-note-table.vue'
import PortausLink from '@/components/portaus-link'

export default {
	name: 'CreditNoteList',
	data() {
		return {
			pageWidth: 0,
			showFilters : false,
			window: {
				width: 0,
				height: 0
			},
		}
	},
	computed: {
		isTileMode(){
			return this.mode=='tile';
		},
		getHeight(){
			return (this.window.height-340);
		},
		getHeightStyle(){
			return "height:" + this.getHeight + "px;";
		},
		creditNotesSearch : {
			set(val){this.setSearch(val);},
			get(){return this.search;}
		},
    orderBy : {
      set(val){this.changeOrderBy(val)},
      get(){return this.getOrderBy()}
    },
    sort_icon : {
      set(val){this.changeSortIcon(val)},
      get(){return this.getSortIcon()}
    },
		...mapState('creditNotes',['creditNotes','list','mode','loading','pages','page','mode','search','outDated','count','icons']),
		...mapGetters('customers',['customerName']),
    ...mapGetters('creditNotes',['isFiltered'])

	},
	watch : {
		outDated : function(val){
			if(this.$refs.infiniteLoading)this.$refs.infiniteLoading.stateChanger.reset();
		}
	},
	methods: {
		load($state) {
			if(this.page <= this.pages){
				this.fetchNextCreditNotesPage()
					.then(()=>{
						if($state){
							$state.loaded();
						}
					})
			}else{
				if($state)$state.complete();
			}

    },
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
		_moment(datetime){
			return  moment(datetime).format('DD/MM/YYYY');
		},
		openInvoice(invoice){
			var index = '/invoices/' + invoice.id;
			this.$router.push(index)
			this.$emit('push-page', {page:index})
		},
		openCreditNotes(creditNote, index){
			this.$emit('select', index)
			// var index = '/credit-notes/' + creditNote.id;
			// this.$router.push(index)
			// this.$emit('push-page', {page:index})
		},
    openClient(client){
			var index = '/customers/' + client.id;
			this.$router.push(index)
			this.$emit('push-page', {page:index})
		},
    sortBy(orderName){

      if(this.orderBy.orderName!=orderName){
        this.orderBy={orderName : orderName, direction:'ASC'};
        this.sort_icon = this.icons['ASC'];
      }else{
        if(this.orderBy.direction=='DESC'){
          this.orderBy={orderName : orderName, direction:'ASC'};
          this.sort_icon = this.icons['ASC'];
        }else{
          this.orderBy={orderName : orderName, direction:'DESC'};
          this.sort_icon = this.icons['DESC'];
        }
      }
    },
    sortIcon(orderName){
      return orderName==this.orderBy.orderName?this.sort_icon:'';

    },
		...mapActions('controlData',['fetchCustomerClasses','fetchCustomerTags']),
		...mapActions('creditNotes', ['fetchCreditNotes','fetchNextCreditNotesPage','changeMode','setSearch','invalidateList','resetAllFilters','changeOrderBy','changeSortIcon']),
    ...mapGetters('creditNotes', ['getOrderBy', 'getSortIcon'])
	},
	mounted() {

	},
	components: {
		CreditNoteTable,
		PortausLink
	},
	created(){
		window.addEventListener('resize', this.handleResize)
		this.handleResize();
	},
	destroyed() {
		this.invalidateList();
		window.removeEventListener('resize', this.handleResize)
	}
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';


.el-table .cell {
  white-space: nowrap;
  overflow: hidden;
	word-break:break-word;
}

.page-customers {
	height: 100%;
	margin: 0 !important;
	padding: 20px;
	padding-bottom: 10px;
	box-sizing: border-box;

	.search-card {
		padding: 50px;
		max-width: 350px;
		//max-height: 720px;
		box-sizing: border-box;
		margin-bottom: 15px;

		.el-input, .el-button {
			width: 100%;
		}
	}

	.search-wrap {
		margin: 0 auto;
		margin-bottom: 10px;
		padding: 0px 30px;
		box-sizing: border-box;
		width: 100%;
		max-width: 600px;

		i {
			display: inline-block;
			width: 22px;
		}

		input {
			outline: none;
			background: transparent;
			border: none;
			font-size: 15px;
			position: relative;
			top: -2px;
			width: 100%;
			padding: 0;
			color: $text-color;
		}

		.contacts-tot {
			margin-right: 20px;
			margin-left: 10px;
		}

		a {
			border-bottom: 1px solid;
			text-decoration: none;
			color: $text-color;

			&:hover {
				opacity: .6;
			}
		}
	}

	.contacts-root {
		max-height: 100%;
	}

	.avatar_user {
		border-radius: 50%;
		width: 35px;
		height: 35px;
		border: 1px solid #FFF;
		margin-left: 20px;
		box-sizing: border-box;
		display: block;
		cursor: pointer;
		box-shadow: 0 2px 5px 0 rgba(49,49,93,.1), 0 1px 2px 0 rgba(0,0,0,.08);
		transition: box-shadow .5s;

		&:hover {
			box-shadow: 0px 3px 10px 0 rgba(49, 49, 93, 0.08), 0px 2px 7px 0 rgba(0, 0, 0, 0.08);
		}
	}

	.contacts-list {
		//margin: 0 auto;
		// width: 100%;
		// max-width: 965px;
		padding: 0px 0px;
		box-sizing: border-box;

		.contact {
			margin: 10px 0;
			// padding: 5px;
			box-sizing: border-box;
			cursor: pointer;
			transition: all .5s .25s;

			.star {
				.mdi-star {
					color: #ffd730;
				}
				.mdi-star-outline {
					opacity: .5;
				}
			}

			.avatar {
				width: 60px;
				transition: all .5s .25s;

				img {
					border: 1px solid transparentize($text-color, .9);
					box-sizing: border-box;
					width: 50px;
					height: 50px;
					border-radius: 50%;
					transition: all .5s .25s;
				}
			}

			.info {
				word-break: break-word;

				.name {

					//.fullname {}

					//.email {
					//	opacity: 0;
					//	line-height: 0;
					//	transition: all .5s .25s;
					//}

					//.phone {
					//	opacity: 0;
					//	line-height: 0;
					//	transition: all .5s .25s;
					//}

					//.phone {
					//	display: none;
					//}
				}

				//.phone {}
			}

			&:hover {
				//margin: 15px -20px;
				//padding: 10px;
				background-color: lighten($background-color, 20%);
				border-radius: 5px;
				box-shadow: 0 8px 16px 0 rgba(40,40,90,.09),0 3px 6px 0 rgba(0,0,0,.065);

				.avatar {
					width: 90px;

					img {
						width: 90px;
						height: 90px;
					}
				}

				.info {
					.name {
						.email {
							opacity: 1;
							line-height: 1.4;
						}

						.phone {
							opacity: 1;
							line-height: 1.4;
						}
					}
				}
			}
		}
	}

	.contacts-root {
		&.medium {
			.search-card {
				padding: 20px;
				max-width: 260px;
				//max-height: 260px;
			}
		}
		&.small {
			overflow-y: auto;
			display: block;
			-webkit-box-orient: vertical;
			-webkit-box-direction: normal;
			-ms-flex-direction: column;
			flex-direction: column;
			padding: 5px;

			.search-card {
				padding: 20px;
				max-width: 100%;
				width: 100%;
				//max-height: 240px;
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}

			.contacts-list {
				flex: none;
				-webkit-box-flex: none;
				-ms-flex: none;
				display: block;
				overflow: hidden !important;
			}
		}
	}
}


@media (max-width: 768px) {

	.page-customers {
		.search-wrap {
			padding: 0;
		}
		.contacts-list {
			padding: 0px;

			.contact {
				.avatar {
					width: 40px;

					img {
						width: 40px;
						height: 40px;
					}
				}

				.info {
					.overdue {
						display: none;
					}

					.name {
						.phone {
							display: block;
						}
					}
				}

				&:hover {
					margin: 15px 0px;

					.avatar {
						width: 60px;

						img {
							width: 60px;
							height: 60px;
						}
					}
				}
			}
		}

		.contacts-root {
			&.medium {
				.contacts-list {
					padding: 0 30px;
				}
			}
			&.small {
				.contacts-list {
					padding: 8px;
				}
			}
		}
	}
}
</style>
